export const getCsvFormatHeader = (
	data: { headerTooltip: string; field: string }[],
) => {
	return data.map(({ headerTooltip, field }) => {
		return { label: headerTooltip, key: field };
	});
};
